import React from "react";
import FooterLinkColumn from "./FooterLinkColumn";
import SocialIcon from "./SocialIcon";
import { faTwitter, faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <>
      <footer className="bg-gray-900 text-white pt-8 pb-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4">
              <h3 className="text-3xl font-semibold mb-4 md:mb-0">
                Let's keep in touch!
              </h3>
              <p className="text-lg mt-0 mb-2 text-gray-500">
                Send us a message with your project needs.
              </p>
              <div className="mt-6">
                <SocialIcon icon={faTwitter} url="https://twitter.com/deepwhitman" />
                <SocialIcon icon={faLinkedin} url="https://www.linkedin.com/in/biltahir" />
                <SocialIcon icon={faGithub} url="https://github.com/btahir" />
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <FooterLinkColumn 
                  header="Products"
                  items={[
                    {
                      label: 'Start',
                      link: '/start'
                    },
                    {
                      label: 'Pricing',
                      link: '/pricing'
                    },                    
                    {
                      label: 'Advanced Services',
                      link: '/services'
                    },
                  ]}
                />
                <FooterLinkColumn 
                  header="Company"
                  items={[
                    {
                      label: 'About Us',
                      link: '/about'
                    },                    
                    {
                      label: 'Contact Us',
                      link: '/contact'
                    },
                    {
                      label: 'Showcase',
                      link: '/templates'
                    }                    
                  ]}
                />
              </div>
            </div>
          </div>          
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-gray-500 font-semibold py-1">
                Copyright © {new Date().getFullYear()}{" "} Done For You Landing
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;